import { connect } from 'react-redux'

import { selectProfile } from 'store/profile/reducer'
import { getTable } from 'store/company/reducer'
import LifeInsuranceAxa from './LifeInsuranceAxa'

const mapStateToProps = state => ({
  user: selectProfile(state),
  table: getTable(state),
})

export default connect(mapStateToProps)(LifeInsuranceAxa)
